<template>
  <div class="print-layout">
    <!-- 페이지 1 -->
    <div class="print-page page-1">
      <!-- 상단 헤더 -->
      <div class="flex flex-col">
        <!-- 결재란 (우상단) -->
        <table class="approval-table">
          <tbody>
            <tr>
              <td style="border: none; font-size: 32px; font-weight: 700; line-height: 1">반기별 보고</td>
              <th rowspan="2" width="3.4%">결<br /><br />재</th>
              <th width="13.5%" height="38">작성자</th>
              <th width="13.5%">검토자</th>
              <th width="13.5%">승인자</th>
            </tr>
            <tr>
              <td height="100" style="border: none"></td>
              <td class="signature-cell">
                <div class="signature-image" v-if="form.sign1.sign">
                  <img :src="form.sign1.sign" alt="작성자 서명" />
                </div>
              </td>
              <td class="signature-cell">
                <div class="signature-image" v-if="form.sign2.sign">
                  <img :src="form.sign2.sign" alt="검토자 서명" />
                </div>
              </td>
              <td class="signature-cell">
                <div class="signature-image" v-if="form.sign3.sign">
                  <img :src="form.sign3.sign" alt="승인자 서명" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div style="margin-top: -1px" class="relative">
          <div class="absolute left-0" style="top: -40px; font-size: 24px; font-weight: 700; line-height: 1">□ 기본정보</div>
          <table class="info-table">
            <tr>
              <th class="label">학교명</th>
              <td class="value">{{ form.stdInfo.field_name || "-" }}</td>
              <th class="label">작성자</th>
              <td class="value">{{ form.stdInfo.writer_name || "-" }}</td>
            </tr>
            <tr>
              <th class="label">작성일</th>
              <td class="value">{{ form.stdInfo.date || "-" }}</td>
              <th class="label">점검일</th>
              <td class="value">{{ form.stdInfo.점검일 || "-" }}</td>
            </tr>
            <tr>
              <th class="label">점검장소</th>
              <td class="value">{{ form.stdInfo.점검장소 || "-" }}</td>
              <th class="label">재해형태</th>
              <td class="value">{{ form.stdInfo.재해형태 || "-" }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 점검 대상 단위사업장 섹션 -->
      <div class="section workplace-info">
        <div class="section-header">
          <span class="section-title">□ 점검 대상 단위사업장</span>
        </div>

        <table class="workplace-table">
          <thead>
            <tr>
              <th>단위사업장명</th>
              <th>담당자</th>
              <th>연락처</th>
              <th>비고</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="form.pobList && form.pobList.length > 0">
              <tr v-for="(item, index) in form.pobList" :key="index">
                <td>{{ item.data1 || "-" }}</td>
                <td>{{ item.data2 || "-" }}</td>
                <td>{{ item.data3 || "-" }}</td>
                <td>{{ item.data4 || "-" }}</td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="4" style="text-align: center">데이터가 없습니다.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 반기별 점검 섹션 -->
      <div class="section inspection-section">
        <div class="section-header">
          <span class="section-title">□ 반기별 점검</span>
        </div>

        <table class="inspection-table">
          <thead>
            <tr>
              <th class="inspection-item-header">자가진단 항목</th>
              <th class="checkbox-header">양호</th>
              <th class="checkbox-header">미흡</th>
              <th class="checkbox-header">해당<br />없음</th>
              <th class="remarks-header">비고(문제점)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in form.inspectList" :key="index">
              <td class="inspection-item">• {{ item.content }}</td>
              <td class="checkbox-cell">
                <div class="print-checkbox" :class="{ checked: item.isChecked === '양호' }">
                  <span v-if="item.isChecked === '양호'">✓</span>
                </div>
              </td>
              <td class="checkbox-cell">
                <div class="print-checkbox" :class="{ checked: item.isChecked === '미흡' }">
                  <span v-if="item.isChecked === '미흡'">✓</span>
                </div>
              </td>
              <td class="checkbox-cell">
                <div class="print-checkbox" :class="{ checked: item.isChecked === '해당없음' }">
                  <span v-if="item.isChecked === '해당없음'">✓</span>
                </div>
              </td>
              <td class="remarks-cell">{{ item["비고(보완계획)"] || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 페이지 2 - 사진대지 1/2 -->
    <div class="print-page page-2">
      <div class="section photo-section">
        <div class="section-header">
          <span class="section-title">□ 사진대지</span>
        </div>

        <div class="photo-grid-page">
          <table class="photo-table">
            <tbody>
              <template v-for="(photo, index) in getPhotos().slice(0, 2)">
                <tr :key="index">
                  <td colspan="2">
                    <div class="photo-frame-large">
                      <img v-if="photo.path" :src="photo.path" :alt="photo.input || ''" />
                      <div v-else class="photo-placeholder-large">
                        <div class="photo-empty-icon">📷</div>
                        <div class="photo-empty-text">이미지 없음</div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr :key="index">
                  <td style="width: 9%; text-align: center">내용</td>
                  <td>{{ photo.input }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Print134",
  props: {
    form: {
      type: Object,
      default: () => ({
        stdInfo: {},
        pobList: [],
        inspectList: [],
        photoList: [],
        sign1: { name: "", sign: "" },
        sign2: { name: "", sign: "" },
        sign3: { name: "", sign: "" },
      }),
    },
  },
  methods: {
    getFormattedDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      return `${year}. ${month}. ${day}. 오후 ${hours}:${minutes}`;
    },
    getPhotos() {
      return this.form.photoList && this.form.photoList.length > 0 ? this.form.photoList : [{}, {}, {}, {}];
    },
  },
};
</script>

<style scoped>
.print-layout {
  font-family: "Malgun Gothic", sans-serif;
  color: #000;
  background: white;
  line-height: 1.4;
}

.print-page {
  margin: 0 auto;
  padding: 20mm;
  box-sizing: border-box;
  page-break-after: always;
  background: white;
  position: relative;
}

.print-page:last-child {
  page-break-after: auto;
}

/* 헤더 스타일 */
.print-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

.header-left .date-info {
  font-size: 12px;
  color: #666;
  margin-bottom: 2px;
}

.header-left .system-info {
  font-size: 12px;
  color: #666;
}

/* 결재란 테이블 */
.approval-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 18px;
}

.approval-table th,
.approval-table td {
  border: 1px solid #000;
  text-align: center;
  vertical-align: middle;
  padding: 2px;
}

.approval-table th {
  background-color: #ececec;
  font-weight: bold;
  font-size: 18px;
}

.signature-cell {
  padding: 2px;
}

.signature-image {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.signature-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* 제목 */
.print-title {
  text-align: center;
  margin: 30px 0;
}

.print-title h1 {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
}

/* 섹션 공통 스타일 */
.section {
  margin-bottom: 25px;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.section-header input[type="checkbox"] {
  margin-right: 8px;
  transform: scale(1.2);
}

.section-title {
  font-weight: bold;
  font-size: 24px;
  margin-top: 36px;
}

/* 테이블 공통 스타일 */
.info-table,
.workplace-table,
.inspection-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 18px;
}
.info-table th {
  width: 13%;
  height: 60px;
  background-color: #ececec;
  font-size: 18px;
  font-weight: 500;
  border: 1px solid #000;
}
.info-table td {
  width: 37%;
}

.workplace-table th,
.inspection-table th {
  background-color: #ececec;
  height: 60px;
  font-size: 18px;
}
.workplace-table td {
  height: 54px;
}
.inspection-table td {
  min-height: 54px;
}

.workplace-table th,
.workplace-table td {
  font-size: 18px;
  width: 25%;
  text-align: center;
}

.info-table td,
.workplace-table th,
.workplace-table td,
.inspection-table th,
.inspection-table td {
  border: 1px solid #000;
  padding: 8px;
}

.info-table .label,
.workplace-table th,
.inspection-table th {
  font-weight: bold;
  text-align: center;
}

.info-table .label {
  width: 100px;
  text-align: center;
}

/* 점검 테이블 특별 스타일 */
.inspection-table .inspection-item-header {
  width: 46%;
}

.inspection-table .checkbox-header {
  width: 8%;
  text-align: center;
}

.inspection-table .remarks-header {
  width: 30%;
}

.inspection-item {
  text-align: left;
  padding-left: 12px;
}

.checkbox-cell {
  text-align: center;
  padding: 4px;
}

.print-checkbox {
  width: 16px;
  height: 16px;
  border: 1px solid #000;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}

.print-checkbox.checked {
  background-color: #000;
  color: white;
}

.remarks-cell {
  color: #666;
  font-size: 18px;
}

/* 사진 섹션 - 새로운 레이아웃 */
.photo-grid-page {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 20px 0;
}

.photo-item-large {
  text-align: center;
  margin-bottom: 30px;
}

.photo-frame-large {
  width: 92%;
  margin: 0 auto;
  aspect-ratio: 3 / 2; /* 3:2 비율 고정 */
  border: 1px solid #ededed;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #f8f9fa;
  min-height: 300px;
}

.photo-frame-large img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.photo-placeholder-large {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #aaa;
  text-align: center;
  padding: 40px 20px;
  height: 100%;
  background-color: #fafafa;
}

.photo-empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.6;
}

.photo-empty-text {
  font-size: 16px;
  font-weight: 500;
  color: #888;
  letter-spacing: 0.5px;
}

.photo-info-large {
  margin-top: 15px;
  padding: 0 10%;
}

.photo-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px;
  color: #333;
}

.photo-meta {
  font-size: 14px;
  color: #666;
  line-height: 1.3;
}

.photo-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 18px;
}
.photo-table td {
  border: 1px solid #000;
  padding: 8px;
}

/* 인쇄 시 스타일 */
@media print {
  .print-layout {
    margin: 0;
    padding: 0;
  }

  .print-page {
    margin: 0;
    box-shadow: none;
    page-break-after: always;
  }

  .print-page:last-child {
    page-break-after: auto;
  }
}
</style>
